import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { ForgetPasswordComponent } from './pages/auth/login/components/forget-password/forget-password.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { OtpCodeComponent } from './pages/auth/login/components/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/login/components/reset-password/reset-password.component';
import { ScanCvComponent } from './pages/scan-cv/scan-cv.component';
import { AuthGuard } from './services/auth/auth.guard';
import { ScanResultComponent } from './pages/scan-result/scan-result.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FAQComponent } from './pages/faq/faq.component';
import { GenerateCVStepsComponent } from './pages/generate resume/generate-cv-steps/generate-cv-steps.component';
import { GetStartComponent } from './pages/generate resume/get-start/get-start.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { CareerCoachComponent } from './pages/career-coach/career-coach.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { ScanLinkedinComponent } from './pages/scan-linkedin/scan-linkedin.component';
import { ScanLinkedinResultComponent } from './pages/scan-linkedin-result/scan-linkedin-result.component';
import { ArticalComponent } from './pages/artical/artical.component';
import { ArticalDetailsComponent } from './pages/artical/components/artical-details/artical-details.component';
import { GenerateLinkedinProfileComponent } from './pages/generate-linkedin-profile/generate-linkedin-profile.component';
import { VirtualInterviewComponent } from './pages/virtual-interview/virtual-interview.component';
import { ReviewResumeComponent } from './pages/generate resume/generate-cv-steps/component/review-resume/review-resume.component';
import { paymentRedirectGuard } from './pages/payment/guards/payment-redirect/payment-redirect.guard';
import { CreateCoverLetterComponent } from './pages/create-cover-letter/create-cover-letter.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'scan-cv', component: ScanCvComponent },
  { path: 'scan-cv-result', component: ScanResultComponent },
  { path: 'scan-linkedin', component: ScanLinkedinComponent },
  { path: 'scan-linkedin-result', component: ScanLinkedinResultComponent },
  { path: 'create-linkedin-profile', component: GenerateLinkedinProfileComponent },
  { path: 'create-cover-letter', component: CreateCoverLetterComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'verify-otp', component: OtpCodeComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'generatResume', component: GetStartComponent },
  { path: 'generatResumeSteps', component: GenerateCVStepsComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'payment-redirect', canActivate: [paymentRedirectGuard], redirectTo: ''},
  { path: 'home', component: HomeComponent },
  { path: 'articles', component: ArticalComponent },
  { path: 'articleDetails/:id', component: ArticalDetailsComponent },
  { path: 'careerCoach', component: CareerCoachComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'policy', component: PolicyPageComponent },
  { path: 'FQA', component: FAQComponent },
  { path: 'soon', component: ComingSoonComponent },
  {path:"virtual-interview",component:VirtualInterviewComponent},
  {path:"cv-review",component:ReviewResumeComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
